<script>
import Vue from 'vue';
import {mapState, mapActions} from 'vuex';
import {required, validEmail} from "../../services/ValidatorService";
import AdminCreateModalFormAccept from '../AdminCreateModalFormAccept/AdminCreateModalFormAccept.vue';

export default Vue.extend({
    components: {
        AdminCreateModalFormAccept
    },
    filters: {
        roleFilter(role) {
            return role.description.substring(role.name.length, role.description.length).toUpperCase();
        }
    },
    computed: {
        ...mapState({
            user: state => state.admin.createModal.user,
            languages: state => state.admin.languages.languages,
            roles: state => state.admin.roles.roles,
        }),
        firstNameClasses() {
            return {
                'admin-create-modal-form__input--error': this.$v.user.firstName.$dirty && this.$v.user.firstName.$error,
                'admin-create-modal-form__input--success': this.$v.user.firstName.$dirty && !this.$v.user.firstName.$error
            }
        },
        lastNameClasses() {
            return {
                'admin-create-modal-form__input--error': this.$v.user.lastName.$dirty && this.$v.user.lastName.$error,
                'admin-create-modal-form__input--success': this.$v.user.lastName.$dirty && !this.$v.user.lastName.$error
            }
        },
        emailClasses() {
            return {
                'admin-create-modal-form__input--error': this.$v.user.email.$dirty && this.$v.user.email.$error,
                'admin-create-modal-form__input--success': this.$v.user.email.$dirty && !this.$v.user.email.$error
            }
        },
        languageClasses() {
            return {
                'admin-create-modal-form__dropdown--error': this.$v.user.language.$dirty && this.$v.user.language.$error,
                'admin-create-modal-form__dropdown--success': this.$v.user.language.$dirty && !this.$v.user.language.$error
            }
        },
    },
    methods: {
        ...mapActions({
            submitCreateUserForm: 'admin/submitCreateUserForm',
            updateCreateUserValues: 'admin/updateCreateUserValues',
            createUser: 'admin/createUser'
        }),
        update(obj) {
            this.$v.$touch();
            this.updateCreateUserValues(obj);
        },
        submit() {
            this.submitCreateUserForm();
        },
        accept() {
            this.createUser(this.user);
        },
        editRoles($event, role) {
            let newRoles = [];
            if ($event.target.checked) {
                newRoles.push(role);
            }
            this.user.roles.forEach((userRole) => {
                if(userRole.id !== role.id) {
                    newRoles.push(userRole);
                }
            });
            this.update({roles: newRoles});
        }
    },
    validations() {
        return {
            user: {
                firstName: {
                    required: (firstName) => {
                        return required(firstName, 'First name').valid;
                    }
                },
                lastName: {
                    required: (lastName) => {
                        return required(lastName, 'Last name').valid;
                    }
                },
                email: {
                    required: (email) => {
                        return required(email, 'Email').valid;
                    },
                    validEmail: (email) => {
                        return validEmail(email).valid;
                    }
                },
                language: {
                    required: (language) => {
                        return required(language, 'Language').valid;
                    }
                }
            }
        }
    }
});
</script>
<template>
    <transition name="fade" mode="out-in">
        <div class="admin-create-modal-form">
            <div class="admin-create-modal-form__info">
                <span v-html="$t('admin.create.form.tip')"/>
            </div>
            <div class="admin-create-modal-form__form">
                <div class="admin-create-modal-form__label">{{ $t('admin.create.form.firstname') }}</div>
                <input :class="firstNameClasses"
                       :value="user.firstName"
                       class="admin-create-modal-form__input"
                       type="text"
                       @input="update({firstName: $event.target.value})">
                <transition name="fade" mode="out-in">
                    <span v-if="$v.user.firstName.$error" class="admin-create-modal-form__error-msg">
                        {{ $t('admin.create.form.validator.firstname') }}
                    </span>
                </transition>
                <div class="admin-create-modal-form__label">{{ $t('admin.create.form.lastname') }}</div>
                <input :class="lastNameClasses"
                       :value="user.lastName"
                       class="admin-create-modal-form__input"
                       type="text"
                       @input="update({lastName: $event.target.value})">
                <transition name="fade" mode="out-in">
                    <span v-if="$v.user.lastName.$error" class="admin-create-modal-form__error-msg">
                        {{ $t('admin.create.form.validator.lastname') }}
                    </span>
                </transition>
                <div class="admin-create-modal-form__label">{{ $t('admin.create.form.email') }}</div>
                <input :class="emailClasses"
                       :value="user.email"
                       class="admin-create-modal-form__input"
                       type="text"
                       @input="update({email: $event.target.value})">
                <transition name="fade" mode="out-in">
                    <span v-if="$v.user.email.$error" class="admin-create-modal-form__error-msg">
                        {{ $t('admin.create.form.validator.email') }}
                    </span>
                </transition>
                <div class="admin-create-modal-form__label">{{ $t('admin.create.form.language') }}</div>
                <select :value="user.language"
                        :class="languageClasses"
                        class="admin-create-modal-form__input-dropdown"
                        @input="update({language: $event.target.value})">
                    <option v-for="(language, index) in languages" :value="index" :key="index">{{ language }}</option>
                </select>
                <div class="admin-create-modal-form__label">{{ $t('admin.create.form.roles') }}</div>
                <div class="admin-create-modal-form__checkbox-group">
                    <div v-for="(role) in roles" :key="role.id" class="admin-create-modal-form__checkbox-element">
                        <label class="admin-create-modal-form__checkbox-label">{{ role | roleFilter }}</label>
                        <input class="admin-create-modal-form__checkbox" type="checkbox" @click="editRoles($event, role)">
                    </div>
                </div>
                <div class="admin-create-modal-form__btn-container">
                    <div class="admin-create-modal-form__btn-group">
                        <button :disabled="!$v.$dirty || $v.$error || user.roles.length === 0" class="admin-create-modal-form__btn admin-create-modal-form__btn-update" @click="submit('create')">
                            {{ $t('admin.create.form.button.submit') }}
                        </button>
                    </div>
                </div>
            </div>
            <admin-create-modal-form-accept @accept="accept"/>
        </div>
    </transition>
</template>



// WEBPACK FOOTER //
// src/components/AdminCreateModalForm/AdminCreateModalForm.vue